import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function ContactSection() {
  const {
    lang
  } = useTranslation();
  return <section className="py-20 bg-dark-bg" data-id="element-141">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="text-center mb-12" data-id="element-143">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-144">
            {lang === 'en' ? <>
                Ready to <span className="text-brand-yellow" data-id="element-145">start?</span>
              </> : <>
                Spremni da <span className="text-brand-yellow" data-id="element-146">počnete?</span>
              </>}
          </h2>
          <p className="text-xl text-gray-400" data-id="element-147">
            {lang === 'en' ? 'Contact our team for expert advice on the right solution for your needs.' : 'Kontaktirajte naš tim za stručne savete o pravom rešenju za vaše potrebe.'}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-148">
          <div className="bg-dark-surface border-2 border-dark-border rounded-industrial p-8 text-center" data-id="element-149">
            <MailIcon className="w-12 h-12 text-brand-yellow mx-auto mb-4" data-id="element-150" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-151">
              {lang === 'en' ? 'Send us an email' : 'Pošaljite nam email'}
            </h3>
            <a href="mailto:info@dtech.rs" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg font-semibold" data-id="element-152">
              info@dtech.rs
            </a>
          </div>
          <div className="bg-dark-surface border-2 border-dark-border rounded-industrial p-8 text-center" data-id="element-153">
            <ClockIcon className="w-12 h-12 text-brand-yellow mx-auto mb-4" data-id="element-154" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-155">
              {lang === 'en' ? 'Working hours' : 'Radno vreme'}
            </h3>
            <p className="text-gray-300 text-lg" data-id="element-156">
              {lang === 'en' ? <>
                  Monday - Friday
                  <br data-id="element-157" />
                  10:00 - 17:00
                </> : <>
                  Ponedeljak - Petak
                  <br data-id="element-158" />
                  10:00 - 17:00
                </>}
            </p>
          </div>
        </div>
        <div className="text-center" data-id="element-159">
          <Link to="/contact" data-id="element-160">
            <Button variant="secondary" size="lg" data-id="element-161">
              {lang === 'en' ? 'Contact us' : 'Kontaktirajte nas'}
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-162" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}